<template>
  <!-- 日常巡检记录列表 -->
  <div>
    <div class="search_wrap">
      <el-form
        :model="queryParam"
        ref="form"
        label-width="80px"
        :inline="true"
        size="mini"
      >
        <el-form-item label="工作社区">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.communityName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="巡检员">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.inspectionUserName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>

        <div class="selectBox">
          <span class="selectText">状态</span>
          <el-select
            v-model="queryParam.status"
            size="mini"
            placeholder="请选择"
          >
            <el-option
              v-for="item in this.options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>

        <div class="selectBox">
          <span class="selectText">巡检日期</span>
          <el-date-picker
            size="mini"
            v-model="inspectionDate"
            @change="dateChange"
            :default-value="dateDefaultShow"
            unlink-panels
            :clearable="false"
            :picker-options="expireTimeOption"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>
        <!-- <el-form-item label="巡检员">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.inspectionUserName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <div class="selectBox">
          <span class="selectText">是否整洁</span>
          <el-select v-model="queryParam.onTidy" size="mini" placeholder="请选择">
            <el-option
              v-for="item in this.options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="selectBox">
          <span class="selectText">是否处罚</span>
          <el-select v-model="queryParam.isPunishment" size="mini" placeholder="请选择">
            <el-option
              v-for="item in this.options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div> -->

        <el-form-item>
          <el-button type="primary" @click="searchQuery">查询</el-button>
          <el-button type="default" @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <e-table
      :listLoading="loading"
      :selection="true"
      :tableHeadConfig="columns"
      @pageChange="loadData"
      :paginationData="ipagination"
      :tableLoadData="dataSource"
      @selectLine="onSelectChange"
      :tableRowClassName="tableRowClassName"
    >
      <template #handlerSlot="slotData">
        <el-button
          size="mini"
          type="primary"
          @click="getInfo(slotData.data.row)"
          >详情</el-button
        >
      </template>
    </e-table>

    <!-- <el-drawer
      title="详细信息"
      :visible.sync="drawerShow"
      direction="rtl"
      :before-close="drawerClose"
    >
      <el-form ref="form" :model="formList" label-width="80px" style="margin-left: 30px">
        <el-form-item v-for="(item, index) in form" :key="index" :label="item.label">
          <el-input type="textarea" :value="formList[item.model]" style="width: 200px" autosize readonly resize="none"></el-input>
        </el-form-item>
        <el-form-item label="小区/村总公示牌达标">
          {{filterFormList.bulletinBoard | radioFilter}}
        </el-form-item>
        <el-form-item label="小区/村总公示牌照片">
          <div v-for="(item, index) in filterFormList.bulletinBoardPhoto" :key="index">
            <el-image
              class="imgBox"
              :src="item"
              :preview-src-list="filterFormList.bulletinBoardPhoto"
              ></el-image>
          </div>
        </el-form-item>
        <el-form-item label="小区/村总公示牌备注">
              {{filterFormList.bulletinBoardRemark}}
        </el-form-item>
      </el-form>
    </el-drawer> -->

    <el-dialog title="详细信息" :visible.sync="drawerShow" width="70%">
      <el-descriptions :column="4" border>
        <el-descriptions-item
          v-for="(item, index) in form"
          :key="index"
          :label="item.label"
          >{{ formList[item.model] }}</el-descriptions-item
        >
      </el-descriptions>
      <el-collapse v-model="activeName" accordion>
        <el-collapse-item title="规范建设及周边日常" name="1">
          <el-descriptions
            :column="3"
            border
            :contentStyle="CS"
            :label-style="LS"
          >
            <el-descriptions-item label="宣传氛围达标率">
              <span>{{
                formList["propagandaAtmosphere"] === null
                  ? "无"
                  : formList["propagandaAtmosphere"] === 0
                  ? "否"
                  : "是"
              }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="宣传氛围照片">
              <div
                style="display: flex"
                v-if="formList['propagandaAtmospherePhoto']"
              >
                <el-image
                  v-for="(item, index) in formList['propagandaAtmospherePhoto']"
                  :key="index"
                  class="imgBox"
                  :src="item"
                  :preview-src-list="formList['propagandaAtmospherePhoto']"
                ></el-image>
              </div>
              <div v-else>无</div>
            </el-descriptions-item>
            <el-descriptions-item label="宣传氛围备注">
              <span>{{
                formList["propagandaAtmosphereRemark"]
                  ? formList["propagandaAtmosphereRemark"]
                  : "无"
              }}</span>
            </el-descriptions-item>

            <el-descriptions-item label="小区/村总公示牌达标率：">
              <span>{{
                formList["bulletinBoard"] === null
                  ? "无"
                  : formList["bulletinBoard"] === 0
                  ? "否"
                  : "是"
              }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="小区/村总公示牌照片">
              <div style="display: flex" v-if="formList['bulletinBoardPhoto']">
                <el-image
                  v-for="(item, index) in formList['bulletinBoardPhoto']"
                  :key="index"
                  class="imgBox"
                  :src="item"
                  :preview-src-list="formList['bulletinBoardPhoto']"
                ></el-image>
              </div>
              <div v-else>无</div>
            </el-descriptions-item>
            <el-descriptions-item label="小区/村总公示牌备注">
              <span>{{
                formList["bulletinBoardRemark"]
                  ? formList["bulletinBoardRemark"]
                  : "无"
              }}</span>
            </el-descriptions-item>

            <el-descriptions-item label="四品类容器齐全率：">
              <span>{{
                formList["fourTypesContainers"] === null
                  ? "无"
                  : formList["fourTypesContainers"] === 0
                  ? "否"
                  : "是"
              }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="四品类容器问题照片">
              <div
                style="display: flex"
                v-if="formList['fourTypesContainersPhoto']"
              >
                <el-image
                  v-for="(item, index) in formList['fourTypesContainersPhoto']"
                  :key="index"
                  class="imgBox"
                  :src="item"
                  :preview-src-list="formList['fourTypesContainersPhoto']"
                ></el-image>
              </div>
              <div v-else>无</div>
            </el-descriptions-item>
            <el-descriptions-item></el-descriptions-item>

            <el-descriptions-item label="厨余和其他桶成组设置率：">
              <span>{{
                formList["groupSettings"] === null
                  ? "无"
                  : formList["groupSettings"] === 0
                  ? "否"
                  : "是"
              }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="厨余和其他桶成组设置问题照片">
              <div style="display: flex" v-if="formList['groupSettingsPhoto']">
                <el-image
                  v-for="(item, index) in formList['groupSettingsPhoto']"
                  :key="index"
                  class="imgBox"
                  :src="item"
                  :preview-src-list="formList['groupSettingsPhoto']"
                ></el-image>
              </div>
              <div v-else>无</div>
            </el-descriptions-item>
            <el-descriptions-item></el-descriptions-item>

            <el-descriptions-item label="容器标识、颜色合格率：">
              <span>{{
                formList["containerIdColorQualified"] === null
                  ? "无"
                  : formList["containerIdColorQualified"] === 0
                  ? "否"
                  : "是"
              }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="容器标识、颜色合格问题照片">
              <div
                style="display: flex"
                v-if="formList['containerIdColorQualifiedPhoto']"
              >
                <el-image
                  v-for="(item, index) in formList[
                    'containerIdColorQualifiedPhoto'
                  ]"
                  :key="index"
                  class="imgBox"
                  :src="item"
                  :preview-src-list="formList['containerIdColorQualifiedPhoto']"
                ></el-image>
              </div>
              <div v-else>无</div>
            </el-descriptions-item>
            <el-descriptions-item></el-descriptions-item>

            <el-descriptions-item label="容器便利性达标率：">
              <span>{{
                formList["containerConvenience"] === null
                  ? "无"
                  : formList["containerConvenience"] === 0
                  ? "否"
                  : "是"
              }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="容器便利性达标问题照片">
              <div
                style="display: flex"
                v-if="formList['containerConveniencePhoto']"
              >
                <el-image
                  v-for="(item, index) in formList['containerConveniencePhoto']"
                  :key="index"
                  class="imgBox"
                  :src="item"
                  :preview-src-list="formList['containerConveniencePhoto']"
                ></el-image>
              </div>
              <div v-else>无</div>
            </el-descriptions-item>
            <el-descriptions-item></el-descriptions-item>

            <el-descriptions-item></el-descriptions-item>
            <el-descriptions-item label="检查照片">
              <div style="display: flex" v-if="formList['containerPhoto']">
                <el-image
                  v-for="(item, index) in formList['containerPhoto']"
                  :key="index"
                  class="imgBox"
                  :src="item"
                  :preview-src-list="formList['containerPhoto']"
                ></el-image>
              </div>
              <div v-else>无</div>
            </el-descriptions-item>
            <el-descriptions-item label="备注">
              <span>{{
                formList["containerRemark"] ? formList["containerRemark"] : "无"
              }}</span>
            </el-descriptions-item>
          </el-descriptions>
        </el-collapse-item>
        <el-collapse-item title="桶站规范建设及周边日常" name="2">
          <el-tabs type="card">
            <el-tab-pane :label="item.garbageStationNo" v-for="item in formList.gsRecordList" :key="item.garbageStationId"> 桶站{{item.garbageStationNo}}
                        <el-descriptions :column="3" border>
                          <el-descriptions-item label="容器完好率：">
                            <span>{{
                              item["containerGoodCondition"] === null
                                ? "无"
                                : item["containerGoodCondition"] === 0
                                ? "否"
                                : "是"
                            }}</span>
                          </el-descriptions-item>
                          <el-descriptions-item label="容器完好问题照片">
                            <div
                              style="display: flex"
                              v-if="item['containerGoodConditionPhoto'].length"
                            >
                              <el-image
                                v-for="(item1, index) in item[
                                  'containerGoodConditionPhoto'
                                ]"
                                :key="index"
                                class="imgBox"
                                :src="item1"
                                :preview-src-list="item['containerGoodConditionPhoto']"
                              ></el-image>
                            </div>
                            <div v-else>无</div>
                          </el-descriptions-item>
                          <el-descriptions-item></el-descriptions-item>

                          <el-descriptions-item label="容器干净率：">
                            <span>{{
                              item["containerClean"] === null
                                ? "无"
                                : item["containerClean"] === 0
                                ? "否"
                                : "是"
                            }}</span>
                          </el-descriptions-item>
                          <el-descriptions-item label="容器干净问题照片">
                            <div style="display: flex" v-if="item['containerCleanPhoto'].length">
                              <el-image
                                v-for="(item1, index) in item['containerCleanPhoto']"
                                :key="index"
                                class="imgBox"
                                :src="item1"
                                :preview-src-list="item['containerCleanPhoto']"
                              ></el-image>
                            </div>
                            <div v-else>无</div>
                          </el-descriptions-item>
                          <el-descriptions-item></el-descriptions-item>

                          <el-descriptions-item label="容器无满冒率：">
                            <span>{{
                              item["containerNotFull"] === null
                                ? "无"
                                : item["containerNotFull"] === 0
                                ? "否"
                                : "是"
                            }}</span>
                          </el-descriptions-item>
                          <el-descriptions-item label="容器无满冒问题照片">
                            <div
                              style="display: flex"
                              v-if="item['containerNotFullPhoto'].length"
                            >
                              <el-image
                                v-for="(item1, index) in item['containerNotFullPhoto']"
                                :key="index"
                                class="imgBox"
                                :src="item1"
                                :preview-src-list="item['containerNotFullPhoto']"
                              ></el-image>
                            </div>
                            <div v-else>无</div>
                          </el-descriptions-item>
                          <el-descriptions-item></el-descriptions-item>

                          <el-descriptions-item label="桶站防雨棚达标率：">
                            <span>{{
                              item["barrelStationAwning"] === null
                                ? "无"
                                : item["barrelStationAwning"] === 0
                                ? "否"
                                : "是"
                            }}</span>
                          </el-descriptions-item>
                          <el-descriptions-item label="桶站防雨棚达标问题照片">
                            <div
                              style="display: flex"
                              v-if="item['barrelStationAwningPhoto'].length"
                            >
                              <el-image
                                v-for="(item1, index) in item['barrelStationAwningPhoto']"
                                :key="index"
                                class="imgBox"
                                :src="item1"
                                :preview-src-list="item['barrelStationAwningPhoto']"
                              ></el-image>
                            </div>
                            <div v-else>无</div>
                          </el-descriptions-item>
                          <el-descriptions-item></el-descriptions-item>

                          <el-descriptions-item label="桶站及周边环境整洁率：">
                            <span>{{
                              item["environmentTidy"] === null
                                ? "无"
                                : item["environmentTidy"] === 0
                                ? "否"
                                : "是"
                            }}</span>
                          </el-descriptions-item>
                          <el-descriptions-item label="桶站及周边环境整洁问题照片">
                            <div
                              style="display: flex"
                              v-if="item['environmentTidyPhoto'].length"
                            >
                              <el-image
                                v-for="(item1, index) in item['environmentTidyPhoto']"
                                :key="index"
                                class="imgBox"
                                :src="item1"
                                :preview-src-list="item['environmentTidyPhoto']"
                              ></el-image>
                            </div>
                            <div v-else>无</div>
                          </el-descriptions-item>
                          <el-descriptions-item></el-descriptions-item>

                          <el-descriptions-item></el-descriptions-item>
                          <el-descriptions-item label="检查照片">
                            <div
                              style="display: flex"
                              v-if="item['stationContainerPhoto'].length"
                            >
                              <el-image
                                v-for="(item1, index) in item['stationContainerPhoto']"
                                :key="index"
                                class="imgBox"
                                :src="item1"
                                :preview-src-list="item['stationContainerPhoto']"
                              ></el-image>
                            </div>
                            <div v-else>无</div>
                          </el-descriptions-item>
                          <el-descriptions-item label="备注">
                            <span>{{
                              item["stationContainerRemark"]
                                ? item["stationContainerRemark"]
                                : "无"
                            }}</span>
                          </el-descriptions-item>

                          <el-descriptions-item label="垃圾分类纯净率：">
                            <span>{{
                              item["wastePurity"] === null
                                ? "无"
                                : item["wastePurity"] === 0
                                ? "否"
                                : "是"
                            }}</span>
                          </el-descriptions-item>
                          <el-descriptions-item label="垃圾分类纯净照片">
                            <div style="display: flex" v-if="item['wastePurityPhoto'].length">
                              <el-image
                                v-for="(item1, index) in item['wastePurityPhoto']"
                                :key="index"
                                class="imgBox"
                                :src="item1"
                                :preview-src-list="item['wastePurityPhoto']"
                              ></el-image>
                            </div>
                            <div v-else>无</div>
                          </el-descriptions-item>
                          <el-descriptions-item label="垃圾分类纯净备注">
                            <span>{{
                              item["wastePurityRemark"]
                                ? item["wastePurityRemark"]
                                : "无"
                            }}</span>
                          </el-descriptions-item>

                          <el-descriptions-item label="桶站公示牌达标率：">
                            <span>{{
                              item["stationBulletinBoard"] === null
                                ? "无"
                                : item["stationBulletinBoard"] === 0
                                ? "否"
                                : "是"
                            }}</span>
                          </el-descriptions-item>
                          <el-descriptions-item label="桶站公示牌达标照片">
                            <div
                              style="display: flex"
                              v-if="item['stationBulletinBoardPhoto'].length"
                            >
                              <el-image
                                v-for="(item1, index) in item['stationBulletinBoardPhoto']"
                                :key="index"
                                class="imgBox"
                                :src="item1"
                                :preview-src-list="item['stationBulletinBoardPhoto']"
                              ></el-image>
                            </div>
                            <div v-else>无</div>
                          </el-descriptions-item>
                          <el-descriptions-item label="桶站公示牌达标备注">
                            <span>{{
                              item["stationBulletinBoardRemark"]
                                ? item["stationBulletinBoardRemark"]
                                : "无"
                            }}</span>
                          </el-descriptions-item>
                        </el-descriptions>
            </el-tab-pane>
          </el-tabs>
          <!-- <div style="width: 96%; margin-left: 2%">
            <el-collapse v-model="activeNames">
              <el-collapse-item v-for="(item, index) in formList.gsRecordList" :key="index" :title="item.garbageStationNo" :name="index + 1">
                <el-descriptions :column="3" border>
                  <el-descriptions-item label="容器完好率：">
                    <span>{{
                      item["containerGoodCondition"] === null
                        ? "无"
                        : item["containerGoodCondition"] === 0
                        ? "否"
                        : "是"
                    }}</span>
                  </el-descriptions-item>
                  <el-descriptions-item label="容器完好问题照片">
                    <div
                      style="display: flex"
                      v-if="item['containerGoodConditionPhoto'].length"
                    >
                      <el-image
                        v-for="(item, index) in item[
                          'containerGoodConditionPhoto'
                        ]"
                        :key="index"
                        class="imgBox"
                        :src="item"
                        :preview-src-list="item['containerGoodConditionPhoto']"
                      ></el-image>
                    </div>
                    <div v-else>无</div>
                  </el-descriptions-item>
                  <el-descriptions-item></el-descriptions-item>

                  <el-descriptions-item label="容器干净率：">
                    <span>{{
                      item["containerClean"] === null
                        ? "无"
                        : item["containerClean"] === 0
                        ? "否"
                        : "是"
                    }}</span>
                  </el-descriptions-item>
                  <el-descriptions-item label="容器干净问题照片">
                    <div style="display: flex" v-if="item['containerCleanPhoto'].length">
                      <el-image
                        v-for="(item, index) in item['containerCleanPhoto']"
                        :key="index"
                        class="imgBox"
                        :src="item"
                        :preview-src-list="item['containerCleanPhoto']"
                      ></el-image>
                    </div>
                    <div v-else>无</div>
                  </el-descriptions-item>
                  <el-descriptions-item></el-descriptions-item>

                  <el-descriptions-item label="容器无满冒率：">
                    <span>{{
                      item["containerNotFull"] === null
                        ? "无"
                        : item["containerNotFull"] === 0
                        ? "否"
                        : "是"
                    }}</span>
                  </el-descriptions-item>
                  <el-descriptions-item label="容器无满冒问题照片">
                    <div
                      style="display: flex"
                      v-if="item['containerNotFullPhoto'].length"
                    >
                      <el-image
                        v-for="(item, index) in item['containerNotFullPhoto']"
                        :key="index"
                        class="imgBox"
                        :src="item"
                        :preview-src-list="item['containerNotFullPhoto']"
                      ></el-image>
                    </div>
                    <div v-else>无</div>
                  </el-descriptions-item>
                  <el-descriptions-item></el-descriptions-item>

                  <el-descriptions-item label="桶站防雨棚达标率：">
                    <span>{{
                      item["barrelStationAwning"] === null
                        ? "无"
                        : item["barrelStationAwning"] === 0
                        ? "否"
                        : "是"
                    }}</span>
                  </el-descriptions-item>
                  <el-descriptions-item label="桶站防雨棚达标问题照片">
                    <div
                      style="display: flex"
                      v-if="item['barrelStationAwningPhoto'].length"
                    >
                      <el-image
                        v-for="(item, index) in item['barrelStationAwningPhoto']"
                        :key="index"
                        class="imgBox"
                        :src="item"
                        :preview-src-list="item['barrelStationAwningPhoto']"
                      ></el-image>
                    </div>
                    <div v-else>无</div>
                  </el-descriptions-item>
                  <el-descriptions-item></el-descriptions-item>

                  <el-descriptions-item label="桶站及周边环境整洁率：">
                    <span>{{
                      item["environmentTidy"] === null
                        ? "无"
                        : item["environmentTidy"] === 0
                        ? "否"
                        : "是"
                    }}</span>
                  </el-descriptions-item>
                  <el-descriptions-item label="桶站及周边环境整洁问题照片">
                    <div
                      style="display: flex"
                      v-if="item['environmentTidyPhoto'].length"
                    >
                      <el-image
                        v-for="(item, index) in item['environmentTidyPhoto']"
                        :key="index"
                        class="imgBox"
                        :src="item"
                        :preview-src-list="item['environmentTidyPhoto']"
                      ></el-image>
                    </div>
                    <div v-else>无</div>
                  </el-descriptions-item>
                  <el-descriptions-item></el-descriptions-item>

                  <el-descriptions-item></el-descriptions-item>
                  <el-descriptions-item label="检查照片">
                    <div
                      style="display: flex"
                      v-if="item['stationContainerPhoto'].length"
                    >
                      <el-image
                        v-for="(item, index) in item['stationContainerPhoto']"
                        :key="index"
                        class="imgBox"
                        :src="item"
                        :preview-src-list="item['stationContainerPhoto']"
                      ></el-image>
                    </div>
                    <div v-else>无</div>
                  </el-descriptions-item>
                  <el-descriptions-item label="备注">
                    <span>{{
                      item["stationContainerRemark"]
                        ? item["stationContainerRemark"]
                        : "无"
                    }}</span>
                  </el-descriptions-item>

                  <el-descriptions-item label="垃圾分类纯净率：">
                    <span>{{
                      item["wastePurity"] === null
                        ? "无"
                        : item["wastePurity"] === 0
                        ? "否"
                        : "是"
                    }}</span>
                  </el-descriptions-item>
                  <el-descriptions-item label="垃圾分类纯净照片">
                    <div style="display: flex" v-if="item['wastePurityPhoto'].length">
                      <el-image
                        v-for="(item, index) in item['wastePurityPhoto']"
                        :key="index"
                        class="imgBox"
                        :src="item"
                        :preview-src-list="item['wastePurityPhoto']"
                      ></el-image>
                    </div>
                    <div v-else>无</div>
                  </el-descriptions-item>
                  <el-descriptions-item label="垃圾分类纯净备注">
                    <span>{{
                      item["wastePurityRemark"]
                        ? item["wastePurityRemark"]
                        : "无"
                    }}</span>
                  </el-descriptions-item>

                  <el-descriptions-item label="桶站公示牌达标率：">
                    <span>{{
                      item["stationBulletinBoard"] === null
                        ? "无"
                        : item["stationBulletinBoard"] === 0
                        ? "否"
                        : "是"
                    }}</span>
                  </el-descriptions-item>
                  <el-descriptions-item label="桶站公示牌达标照片">
                    <div
                      style="display: flex"
                      v-if="item['stationBulletinBoardPhoto'].length"
                    >
                      <el-image
                        v-for="(item, index) in item['stationBulletinBoardPhoto']"
                        :key="index"
                        class="imgBox"
                        :src="item"
                        :preview-src-list="item['stationBulletinBoardPhoto']"
                      ></el-image>
                    </div>
                    <div v-else>无</div>
                  </el-descriptions-item>
                  <el-descriptions-item label="桶站公示牌达标备注">
                    <span>{{
                      item["stationBulletinBoardRemark"]
                        ? item["stationBulletinBoardRemark"]
                        : "无"
                    }}</span>
                  </el-descriptions-item>
                </el-descriptions>
              </el-collapse-item>
            </el-collapse>
          </div> -->
        </el-collapse-item>
        <el-collapse-item title="可回收物交投点建设和管理" name="3">
          <el-descriptions
            :column="3"
            :contentStyle="CS"
            :label-style="LS"
            border
          >
            <el-descriptions-item label="分类驿站（或固定交投点）建设达标率：">
              <span>{{
                formList["stationConstruction"] === null
                  ? "无"
                  : formList["stationConstruction"] === 0
                  ? "否"
                  : "是"
              }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="分类驿站（或固定交投点）建设达标问题照片">
              <div
                style="display: flex"
                v-if="formList['stationConstructionPhoto']"
              >
                <el-image
                  v-for="(item, index) in formList['stationConstructionPhoto']"
                  :key="index"
                  class="imgBox"
                  :src="item"
                  :preview-src-list="formList['stationConstructionPhoto']"
                ></el-image>
              </div>
              <div v-else>无</div>
            </el-descriptions-item>
            <el-descriptions-item></el-descriptions-item>

            <el-descriptions-item
              label="分类驿站（或固定交投点）运行管理达标率："
            >
              <span>{{
                formList["stationManagement"] === null
                  ? "无"
                  : formList["stationManagement"] === 0
                  ? "否"
                  : "是"
              }}</span>
            </el-descriptions-item>
            <el-descriptions-item
              label="分类驿站（或固定交投点）运行管理达标问题照片"
            >
              <div
                style="display: flex"
                v-if="formList['stationManagementPhoto']"
              >
                <el-image
                  v-for="(item, index) in formList['stationManagementPhoto']"
                  :key="index"
                  class="imgBox"
                  :src="item"
                  :preview-src-list="formList['stationManagementPhoto']"
                ></el-image>
              </div>
              <div v-else>无</div>
            </el-descriptions-item>
            <el-descriptions-item></el-descriptions-item>

            <el-descriptions-item></el-descriptions-item>
            <el-descriptions-item label="检查照片">
              <div style="display: flex" v-if="formList['sortingStationPhoto']">
                <el-image
                  v-for="(item, index) in formList['sortingStationPhoto']"
                  :key="index"
                  class="imgBox"
                  :src="item"
                  :preview-src-list="formList['sortingStationPhoto']"
                ></el-image>
              </div>
              <div v-else>无</div>
            </el-descriptions-item>
            <el-descriptions-item label="备注">
              <span>{{
                formList["sortingStationRemark"] ? formList["sortingStationRemark"] : "无"
              }}</span>
            </el-descriptions-item>
          </el-descriptions>
        </el-collapse-item>
        <el-collapse-item title="大件垃圾投放点建设和管理、乱堆乱放" name="4">
          <el-descriptions :column="3" :contentStyle="CS" :label-style="LS" border>
            <el-descriptions-item label="大件垃圾投放点建设达标率：">
              <span>{{
                formList["largeGarbagePointsConstruction"] === null
                  ? "无"
                  : formList["largeGarbagePointsConstruction"] === 0
                  ? "否"
                  : "是"
              }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="大件垃圾投放点建设问题照片">
              <div
                style="display: flex"
                v-if="formList['largeGarbagePointsConstructionPhoto']"
              >
                <el-image
                  v-for="(item, index) in formList[
                    'largeGarbagePointsConstructionPhoto'
                  ]"
                  :key="index"
                  class="imgBox"
                  :src="item"
                  :preview-src-list="
                    formList['largeGarbagePointsConstructionPhoto']
                  "
                ></el-image>
              </div>
              <div v-else>无</div>
            </el-descriptions-item>
            <el-descriptions-item></el-descriptions-item>

            <el-descriptions-item label="大件垃圾投放点运行管理达标率：">
              <span>{{
                formList["largeGarbagePointsManagement"] === null
                  ? "无"
                  : formList["largeGarbagePointsManagement"] === 0
                  ? "否"
                  : "是"
              }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="大件垃圾投放点运行管理问题照片">
              <div
                style="display: flex"
                v-if="formList['largeGarbagePointsManagementPhoto']"
              >
                <el-image
                  v-for="(item, index) in formList[
                    'largeGarbagePointsManagementPhoto'
                  ]"
                  :key="index"
                  class="imgBox"
                  :src="item"
                  :preview-src-list="
                    formList['largeGarbagePointsManagementPhoto']
                  "
                ></el-image>
              </div>
              <div v-else>无</div>
            </el-descriptions-item>
            <el-descriptions-item></el-descriptions-item>

            <el-descriptions-item></el-descriptions-item>
            <el-descriptions-item label="检查照片">
              <div style="display: flex" v-if="formList['largeGarbagePointsPhoto']">
                <el-image
                  v-for="(item, index) in formList['largeGarbagePointsPhoto']"
                  :key="index"
                  class="imgBox"
                  :src="item"
                  :preview-src-list="formList['largeGarbagePointsPhoto']"
                ></el-image>
              </div>
              <div v-else>无</div>
            </el-descriptions-item>
            <el-descriptions-item label="备注">
              <span>{{
                formList["largeGarbagePointsRemark"] ? formList["largeGarbagePointsRemark"] : "无"
              }}</span>
            </el-descriptions-item>

            <el-descriptions-item
              label="小区/村大件或装修垃圾乱投、乱放处次数达标率："
            >
              <span>{{
                formList["garbageLittering"] === null
                  ? "无"
                  : formList["garbageLittering"] === 0
                  ? "否"
                  : "是"
              }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="小区/村大件或装修垃圾乱投、乱放照片">
              <div
                style="display: flex"
                v-if="formList['garbageLitteringPhoto']"
              >
                <el-image
                  v-for="(item, index) in formList['garbageLitteringPhoto']"
                  :key="index"
                  class="imgBox"
                  :src="item"
                  :preview-src-list="formList['garbageLitteringPhoto']"
                ></el-image>
              </div>
              <div v-else>无</div>
            </el-descriptions-item>
            <el-descriptions-item label="小区/村大件或装修垃圾乱投、乱放备注">
              <span>{{
                formList["garbageLitteringRemark"]
                  ? formList["garbageLitteringRemark"]
                  : "无"
              }}</span>
            </el-descriptions-item>

            <el-descriptions-item label="装修垃圾投放点建设达标率：">
              <span>{{
                formList["decorationGarbagePointsConstruction"] === null
                  ? "无"
                  : formList["decorationGarbagePointsConstruction"] === 0
                  ? "否"
                  : "是"
              }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="装修垃圾投放点建设达标问题照片">
              <div
                style="display: flex"
                v-if="formList['decorationGarbagePointsConstructionPhoto']"
              >
                <el-image
                  v-for="(item, index) in formList[
                    'decorationGarbagePointsConstructionPhoto'
                  ]"
                  :key="index"
                  class="imgBox"
                  :src="item"
                  :preview-src-list="
                    formList['decorationGarbagePointsConstructionPhoto']
                  "
                ></el-image>
              </div>
              <div v-else>无</div>
            </el-descriptions-item>
            <el-descriptions-item></el-descriptions-item>
            <el-descriptions-item label="装修垃圾投放点运行管理达标率：">
              <span>{{
                formList["decorationGarbagePointsManagement"] === null
                  ? "无"
                  : formList["decorationGarbagePointsManagement"] === 0
                  ? "否"
                  : "是"
              }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="装修垃圾投放点运行管理达标问题照片">
              <div
                style="display: flex"
                v-if="formList['decorationGarbagePointsManagementPhoto']"
              >
                <el-image
                  v-for="(item, index) in formList[
                    'decorationGarbagePointsManagementPhoto'
                  ]"
                  :key="index"
                  class="imgBox"
                  :src="item"
                  :preview-src-list="
                    formList['decorationGarbagePointsManagementPhoto']
                  "
                ></el-image>
              </div>
              <div v-else>无</div>
            </el-descriptions-item>
            <el-descriptions-item></el-descriptions-item>

            <el-descriptions-item></el-descriptions-item>
            <el-descriptions-item label="检查照片">
              <div style="display: flex" v-if="formList['decorationGarbagePointsPhoto']">
                <el-image
                  v-for="(item, index) in formList['decorationGarbagePointsPhoto']"
                  :key="index"
                  class="imgBox"
                  :src="item"
                  :preview-src-list="formList['decorationGarbagePointsPhoto']"
                ></el-image>
              </div>
              <div v-else>无</div>
            </el-descriptions-item>
            <el-descriptions-item label="备注">
              <span>{{
                formList["decorationGarbagePointsRemark"] ? formList["decorationGarbagePointsRemark"] : "无"
              }}</span>
            </el-descriptions-item>

            <el-descriptions-item
              label="投放点公示有效期内的《建筑垃圾消纳备案》："
            >
              <span>{{
                formList["decorationGarbagePointsRecord"] === null
                  ? "无"
                  : formList["decorationGarbagePointsRecord"] === 0
                  ? "否"
                  : "是"
              }}</span>
            </el-descriptions-item>
            <el-descriptions-item
              label="投放点公示有效期内的《建筑垃圾消纳备案》照片"
            >
              <div
                style="display: flex"
                v-if="formList['decorationGarbagePointsRecordPhoto']"
              >
                <el-image
                  v-for="(item, index) in formList[
                    'decorationGarbagePointsRecordPhoto'
                  ]"
                  :key="index"
                  class="imgBox"
                  :src="item"
                  :preview-src-list="
                    formList['decorationGarbagePointsRecordPhoto']
                  "
                ></el-image>
              </div>
              <div v-else>无</div>
            </el-descriptions-item>
            <el-descriptions-item
              label="投放点公示有效期内的《建筑垃圾消纳备案》备注"
            >
              <span>{{
                formList["decorationGarbagePointsRecordRemark"]
                  ? formList["decorationGarbagePointsRecordRemark"]
                  : "无"
              }}</span>
            </el-descriptions-item>
          </el-descriptions>
        </el-collapse-item>
        <el-collapse-item title="收运合同管理" name="5">
          <el-descriptions :column="3" border>
            <el-descriptions-item label="厨余垃圾合同签订达标率：">
              <span>{{
                formList["kitchenWasteContractRecord"] === null
                  ? "无"
                  : formList["kitchenWasteContractRecord"] === 0
                  ? "否"
                  : "是"
              }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="厨余垃圾合同签订达标照片">
              <div
                style="display: flex"
                v-if="formList['kitchenWasteContractRecordPhoto']"
              >
                <el-image
                  v-for="(item, index) in formList[
                    'kitchenWasteContractRecordPhoto'
                  ]"
                  :key="index"
                  class="imgBox"
                  :src="item"
                  :preview-src-list="
                    formList['kitchenWasteContractRecordPhoto']
                  "
                ></el-image>
              </div>
              <div v-else>无</div>
            </el-descriptions-item>
            <el-descriptions-item label="厨余垃圾合同签订达标备注">
              <span>{{
                formList["kitchenWasteContractRecordRemark"]
                  ? formList["kitchenWasteContractRecordRemark"]
                  : "无"
              }}</span>
            </el-descriptions-item>

            <el-descriptions-item label="其他垃圾合同签订达标率：">
              <span>{{
                formList["otherGarbageContract"] === null
                  ? "无"
                  : formList["otherGarbageContract"] === 0
                  ? "否"
                  : "是"
              }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="其他垃圾合同签订达标照片">
              <div
                style="display: flex"
                v-if="formList['otherGarbageContractPhoto']"
              >
                <el-image
                  v-for="(item, index) in formList['otherGarbageContractPhoto']"
                  :key="index"
                  class="imgBox"
                  :src="item"
                  :preview-src-list="formList['otherGarbageContractPhoto']"
                ></el-image>
              </div>
              <div v-else>无</div>
            </el-descriptions-item>
            <el-descriptions-item label="其他垃圾合同签订达标备注">
              <span>{{
                formList["otherGarbageContractRemark"]
                  ? formList["otherGarbageContractRemark"]
                  : "无"
              }}</span>
            </el-descriptions-item>

            <el-descriptions-item label="可回收物合同签订达标率：">
              <span>{{
                formList["recyclablesContract"] === null
                  ? "无"
                  : formList["recyclablesContract"] === 0
                  ? "否"
                  : "是"
              }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="可回收物合同签订达标照片">
              <div
                style="display: flex"
                v-if="formList['recyclablesContractPhoto']"
              >
                <el-image
                  v-for="(item, index) in formList['recyclablesContractPhoto']"
                  :key="index"
                  class="imgBox"
                  :src="item"
                  :preview-src-list="formList['recyclablesContractPhoto']"
                ></el-image>
              </div>
              <div v-else>无</div>
            </el-descriptions-item>
            <el-descriptions-item label="可回收物合同签订达标备注">
              <span>{{
                formList["recyclablesContractRemark"]
                  ? formList["recyclablesContractRemark"]
                  : "无"
              }}</span>
            </el-descriptions-item>

            <el-descriptions-item label="有害垃圾合同签订达标率：">
              <span>{{
                formList["hazardousWasteContract"] === null
                  ? "无"
                  : formList["hazardousWasteContract"] === 0
                  ? "否"
                  : "是"
              }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="有害垃圾合同签订达标照片">
              <div
                style="display: flex"
                v-if="formList['hazardousWasteContractPhoto']"
              >
                <el-image
                  v-for="(item, index) in formList[
                    'hazardousWasteContractPhoto'
                  ]"
                  :key="index"
                  class="imgBox"
                  :src="item"
                  :preview-src-list="formList['hazardousWasteContractPhoto']"
                ></el-image>
              </div>
              <div v-else>无</div>
            </el-descriptions-item>
            <el-descriptions-item label="有害垃圾合同签订达标备注">
              <span>{{
                formList["hazardousWasteContractRemark"]
                  ? formList["hazardousWasteContractRemark"]
                  : "无"
              }}</span>
            </el-descriptions-item>

            <el-descriptions-item label="大件垃圾合同签订达标率：">
              <span>{{
                formList["largeWasteContract"] === null
                  ? "无"
                  : formList["largeWasteContract"] === 0
                  ? "否"
                  : "是"
              }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="大件垃圾合同签订达标照片">
              <div
                style="display: flex"
                v-if="formList['largeWasteContractPhoto']"
              >
                <el-image
                  v-for="(item, index) in formList['largeWasteContractPhoto']"
                  :key="index"
                  class="imgBox"
                  :src="item"
                  :preview-src-list="formList['largeWasteContractPhoto']"
                ></el-image>
              </div>
              <div v-else>无</div>
            </el-descriptions-item>
            <el-descriptions-item label="大件垃圾合同签订达标备注">
              <span>{{
                formList["largeWasteContractRemark"]
                  ? formList["largeWasteContractRemark"]
                  : "无"
              }}</span>
            </el-descriptions-item>

            <el-descriptions-item label="装修垃圾合同签订达标率：">
              <span>{{
                formList["decorationWasteContract"] === null
                  ? "无"
                  : formList["decorationWasteContract"] === 0
                  ? "否"
                  : "是"
              }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="装修垃圾合同签订达标照片">
              <div
                style="display: flex"
                v-if="formList['decorationWasteContractPhoto']"
              >
                <el-image
                  v-for="(item, index) in formList[
                    'decorationWasteContractPhoto'
                  ]"
                  :key="index"
                  class="imgBox"
                  :src="item"
                  :preview-src-list="formList['decorationWasteContractPhoto']"
                ></el-image>
              </div>
              <div v-else>无</div>
            </el-descriptions-item>
            <el-descriptions-item label="装修垃圾合同签订达标备注">
              <span>{{
                formList["decorationWasteContractRemark"]
                  ? formList["decorationWasteContractRemark"]
                  : "无"
              }}</span>
            </el-descriptions-item>

            <el-descriptions-item label="建立薄弱对象清单：">
              <span>{{
                formList["weakObjectList"] === null
                  ? "无"
                  : formList["weakObjectList"] === 0
                  ? "否"
                  : "是"
              }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="建立薄弱对象清单照片">
              <div style="display: flex" v-if="formList['weakObjectListPhoto']">
                <el-image
                  v-for="(item, index) in formList['weakObjectListPhoto']"
                  :key="index"
                  class="imgBox"
                  :src="item"
                  :preview-src-list="formList['weakObjectListPhoto']"
                ></el-image>
              </div>
              <div v-else>无</div>
            </el-descriptions-item>
            <el-descriptions-item label="建立薄弱对象清单备注">
              <span>{{
                formList["weakObjectListRemark"]
                  ? formList["weakObjectListRemark"]
                  : "无"
              }}</span>
            </el-descriptions-item>
          </el-descriptions>
        </el-collapse-item>
        <!-- <el-collapse-item title="收运管理" name="6">
          <el-descriptions :column="3" border>
            <el-descriptions-item label="大件垃圾投放点建设达标率：">
              <span>{{
                formList["largeGarbagePointsConstruction"] === null
                  ? "无"
                  : formList["largeGarbagePointsConstruction"] === 0
                  ? "否"
                  : "是"
              }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="大件垃圾投放点建设达标照片">
              <div
                style="display: flex"
                v-if="formList['largeGarbagePointsConstructionPhoto']"
              >
                <el-image
                  v-for="(item, index) in formList[
                    'largeGarbagePointsConstructionPhoto'
                  ]"
                  :key="index"
                  class="imgBox"
                  :src="item"
                  :preview-src-list="
                    formList['largeGarbagePointsConstructionPhoto']
                  "
                ></el-image>
              </div>
              <div v-else>无</div>
            </el-descriptions-item>
            <el-descriptions-item label="大件垃圾投放点建设达标备注">
              <span>{{
                formList["largeGarbagePointsConstructionRemark"]
                  ? formList["largeGarbagePointsConstructionRemark"]
                  : "无"
              }}</span>
            </el-descriptions-item>

            <el-descriptions-item label="大件垃圾投放点运行管理达标率：">
              <span>{{
                formList["largeGarbagePointsManagement"] === null
                  ? "无"
                  : formList["largeGarbagePointsManagement"] === 0
                  ? "否"
                  : "是"
              }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="大件垃圾投放点运行管理达标照片">
              <div
                style="display: flex"
                v-if="formList['largeGarbagePointsManagementPhoto']"
              >
                <el-image
                  v-for="(item, index) in formList[
                    'largeGarbagePointsManagementPhoto'
                  ]"
                  :key="index"
                  class="imgBox"
                  :src="item"
                  :preview-src-list="
                    formList['largeGarbagePointsManagementPhoto']
                  "
                ></el-image>
              </div>
              <div v-else>无</div>
            </el-descriptions-item>
            <el-descriptions-item label="大件垃圾投放点运行管理达标备注">
              <span>{{
                formList["largeGarbagePointsManagementRemark"]
                  ? formList["largeGarbagePointsManagementRemark"]
                  : "无"
              }}</span>
            </el-descriptions-item>
          </el-descriptions>
        </el-collapse-item>
        <el-collapse-item title="大件装修乱堆乱放" name="7">
          <el-descriptions :column="3" border>
            <el-descriptions-item
              label="小区/村大件或装修垃圾乱投、乱放处次数达标率："
            >
              <span>{{
                formList["garbageLittering"] === null
                  ? "无"
                  : formList["garbageLittering"] === 0
                  ? "否"
                  : "是"
              }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="小区/村大件或装修垃圾乱投、乱放照片">
              <div
                style="display: flex"
                v-if="formList['garbageLitteringPhoto']"
              >
                <el-image
                  v-for="(item, index) in formList['garbageLitteringPhoto']"
                  :key="index"
                  class="imgBox"
                  :src="item"
                  :preview-src-list="formList['garbageLitteringPhoto']"
                ></el-image>
              </div>
              <div v-else>无</div>
            </el-descriptions-item>
            <el-descriptions-item label="小区/村大件或装修垃圾乱投、乱放备注">
              <span>{{
                formList["garbageLitteringRemark"]
                  ? formList["garbageLitteringRemark"]
                  : "无"
              }}</span>
            </el-descriptions-item>
          </el-descriptions>
        </el-collapse-item> -->
      </el-collapse>
      <!-- <el-descriptions :column="3" border>
        <el-descriptions-item v-for="(item, index) in form" :key="index" :label="item.label">{{formList[item.model]}}</el-descriptions-item>
        <el-descriptions-item label="小区/村总公示牌达标" v-for="(val, key, index) in filterFormList" :key="index">
          <span v-if="val === 1 || 0">{{filterFormList[key] | radioFilter}}</span>
          <div v-else-if="Array.isArray(val)" style="display: flex;">
            <el-image
              v-for="(item, index) in filterFormList[key]" :key="index"
              class="imgBox"
              :src="item"
              :preview-src-list="filterFormList[key]"
              ></el-image>
          </div>
          <span v-else>{{filterFormList[key]}}</span>
        </el-descriptions-item>
      </el-descriptions> -->
    </el-dialog>
  </div>
</template>

<script>
import eTable from "@/components/table";
import { listMixin } from "@/mixins/listMixin";
import { httpAction } from "@/api/manage";
export default {
  components: { eTable },
  mixins: [listMixin],
  data() {
    return {
      inspectionDate: "",
      dateDefaultShow: "",
      expireTimeOption: {
        disabledDate(date) {
          return date.getTime() >= Date.now();
        },
      },
      CS: {
        "text-align": "center", //文本居中
        "word-break": "break-all", //过长时自动换行
      },
      LS: { width: "200px" },
      url: {
        list: "/dailyInspectionMange/list",
        getDetail: "/dailyInspectionMange/detail/{id}",
      },
      loading: false,
      queryParam: {
        // userName: "",
        // inspectionUserName: "",
        // communityName: "",
        // inspectionDateStart: '',
        // inspectionDateEnd: '',
        // onDuty: '',
        // onTidy: '',
        // isPunishment: ''
      },
      options: [
        {
          value: 1,
          label: "草稿",
        },
        {
          value: 2,
          label: "已巡检",
        },
      ],
      activeName: "1",
      activeNames: "1",
      columns: [
        { field: "inspectionUserName", label: "巡检员" },
        { field: "communityName", label: "工作社区" },
        { field: "communityPhone", label: "社区电话" },
        { field: "contactPerson", label: "负责人" },
        { field: "contactPhone", label: "负责人电话" },
        // { field: "garbageStationNo", label: "被检桶站" },
        { field: "inspectionTime", label: "巡检时间" },
        { field: "status", label: "状态" },
        // { field: "position", label: "位置" },
        {
          width: 200,
          label: "操作",
          slotName: "handlerSlot",
          columnType: "slot",
        },
      ],
      form: [
        { label: "巡检员", model: "inspectionUserName" },
        { label: "工作社区", model: "communityName" },
        { label: "巡检时间", model: "inspectionTime" },
        { label: "定位", model: "position" },
        { label: "物业联系人", model: "contactPerson" },
        { label: "物业联系电话", model: "contactPhone" },
        { label: "居委会联系人", model: "communityPerson" },
        { label: "居委会联系电话", model: "communityPhone" },
      ],
      drawerShow: false,
      formList: {},
      filterFormList: {},
      srcList: [],
    };
  },
  filters: {
    // radioFilter(val) {
    //   if (val === 0) return (val = "未达标");
    //   if (val === 1) return (val = "是");
    // },
  },
  mounted() {
    this.dateDefaultShow = new Date();
    this.dateDefaultShow.setMonth(new Date().getMonth() - 1);
  },
  updated() {
    this.dataSource.forEach((item) => {
      if (item.status === 1 || item.status === 2)
        item.status = item.status === 1 ? "草稿" : "已巡检";
    });
  },
  methods: {
    dateChange(date) {
      this.queryParam.inspectionDateStart = date[0] + " 00:00:00";
      this.queryParam.inspectionDateEnd = date[1] + " 23:59:59";
    },
    resetForm() {
      this.queryParam = {
        // userName: "",
        // inspectionUserName: "",
        // communityName: "",
        // inspectionDateStart: "",
        // inspectionDateEnd: "",
        // onDuty: "",
        // onTidy: "",
        // isPunishment: "",
      };
      this.inspectionDate = "";
      this.searchQuery();
    },
    getInfo(val) {
      this.drawerShow = true;
      httpAction("/dailyInspectionMange/detail/" + val.id, {}, "get").then(
        ({ code, data }) => {
          if (code === 200) {
            console.log(data);
            const {
              id,
              wlCommunityId,
              wlStreetId,
              wlUserId,
              garbageStationId,
              garbageStationNo,
              inspectionUserName,
              communityName,
              contactPerson,
              contactPhone,
              inspectionTime,
              position,
              ...newData
            } = data;
            this.formList = data;
            this.filterFormList = newData;
            console.log(this.filterFormList);
            console.log(this.formList);
          }
        }
      );
    },
    drawerClose() {
      this.drawerShow = false;
      (this.formList = {}), (this.filterFormList = {});
    },
  },
};
</script>

<style scoped lang="scss">
.search_wrap {
  margin: 10px 0;
}
.imgBox {
  width: 100px;
  height: 150px;
  margin-right: 10px;
  border: 1px solid rgb(223, 212, 212);
}
.selectBox {
  margin-bottom: 18px;
  display: inline-block;
  margin-right: 10px;
  vertical-align: top;
}
.selectText {
  width: 80px;
  line-height: 28px;
  font-weight: 700;
  cursor: default;
  float: none;
  display: inline-block;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  padding: 0 12px 0 0;
  box-sizing: border-box;
}
::v-deep.el-tabs {
  display: flex;
  flex-direction: column;
  height: 100%;
  :deep {
    .el-tabs__content {
      flex: 1;
    }
    .el-tab-pane {
      height: 100%;
    }
  }
}
</style>